import { ValidatorService } from './tools/validator.service';
import { AutenticacionService } from './autenticacion.service';
import { Http, URLSearchParams,RequestOptions  } from '@angular/http';
import { ConstantsService } from './constants.service';
import { Injectable, Output, EventEmitter } from '@angular/core';
import { ErrorsService } from './tools/errors.service';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
declare var $;

@Injectable()
export class CreditosService {

  private service_url : string;
  private calculos_service_url : string;
  private tiposCreditosService :  string;
  private authCreditoUrl :  string;
  private iniciarCreditoUrl :  string;

  constructor(
      private constantsService: ConstantsService, 
      private http: Http, 
      private authService: AutenticacionService, 
      private validatorService: ValidatorService, 
      private errorService: ErrorsService) {
    this.calculos_service_url = this.constantsService.apiURL + '/calculo';
    this.service_url = this.constantsService.apiURL + '/creditos';
    this.tiposCreditosService = this.constantsService.apiURL + '/tipos-creditos';
    this.authCreditoUrl = this.constantsService.apiURL + '/authsCreditos';
    this.iniciarCreditoUrl = this.constantsService.apiURL + '/creditos/iniciar';
  }

  //Es utilizado en la pantalla de detalles, para informar cuando alguno de los formularios actualizo su información
  //Ya que esto pudo ocasion que el estatus de las validaciones haya cambiado
  @Output() changeCredito: EventEmitter<boolean> = new EventEmitter();
  reloadCreditoStatus() {
    this.changeCredito.emit();
  }

  getDefaultSchedule() {
    return {
      'id': '',
      'promedio_mensual': '',
      'buro_mensual': '',
      'capacidad_pago': ''
    };
  }
  getAll(filters : any) {
    let myParams = new URLSearchParams();
    myParams.append('paginate', 'true');
    
    let serviceUrl = this.service_url + '?paginate=true';
    if(filters.page){
      myParams.append('page', filters.page);
    }
    if(filters.search){
      myParams.append('search', filters.search);
    }
    if(filters.status){
      myParams.append('status-credito', filters.status);
    }
    if(filters.tipoCredito){
      myParams.append('tipo-credito', filters.tipoCredito);
    }
    if(filters.sucursal){
      myParams.append('sucursal', filters.sucursal);
    }
    if(filters.fechaInicio){
      myParams.append('start-date', filters.fechaInicio);
    }
    if(filters.cliente){
      myParams.append('cliente', filters.cliente);
    }
    let myoptions = this.authService.getAuthHeaders();
    myoptions.params = myParams;
      console.log(this.service_url , myoptions);
    return this.http.get(this.service_url , myoptions);
  } 

  get(id:number) {
    return this.http.get(this.service_url + "/" + id, this.authService.getAuthHeaders());
  }

  public update(credito : object) {
    return this.http.put(this.service_url , credito, this.authService.getAuthHeaders());
  }

  public iniciarCredito(idCreditos: number) {
    let serviceUrl = this.iniciarCreditoUrl + '/' + idCreditos;
    return this.http.post(serviceUrl, {}, this.authService.getAuthHeaders());
  }

  public getTablaAmortizacion(id:number) {
    return this.http.get(this.calculos_service_url + '/tablaAmortizacion/' + id, this.authService.getAuthHeaders());
  }

  public getAmortizacionSimple(id:number) {
    return this.http.get(this.calculos_service_url + '/tablaAmortizacion/' + id, this.authService.getAuthHeaders());
  }

  isValidToCreateContrato(id:number) {
    const urlService = this.service_url + '/utilerias/isValidToCreateContrato/' + id;
    return this.http.get(urlService, this.authService.getAuthHeaders());
  }

  public isValidToStartCredito(id:number) {
    const urlService = this.service_url + '/utilerias/isValidToStartCredito/' + id;
    return this.http.get(urlService, this.authService.getAuthHeaders());
  }

  public requireAuthorization(id:number) {
    const urlService = this.service_url + '/utilerias/requireAuthorization/' + id;
    return this.http.get(urlService, this.authService.getAuthHeaders());
  }

  public autorizarCredito(id:number) {
    const credito = { idCreditos: id};
    return this.http.post(this.authCreditoUrl, credito, this.authService.getAuthHeaders());
  }

  public isValidUpdateFechaContrato(id: number) {
    const urlService = this.service_url + '/utilerias/isValidUpdateFechaContrato/' + id;
    return this.http.get(urlService, this.authService.getAuthHeaders());
  }

  public updateFechaContrato(data: any) {
    const urlService = this.service_url + '/fechaContrato';
    return this.http.put(urlService , data, this.authService.getAuthHeaders());
  }

  public updatePromotor(data: any) {
    const urlService = this.service_url + '/promotor';
    return this.http.put(urlService , data, this.authService.getAuthHeaders());
  }

  /**
   * Revisa si las secciones del crédito estan completas
   */
  validateSections(idCreditos : number){
    return this.http.get(this.service_url + '/utilerias/validateSections/'+ idCreditos  , this.authService.getAuthHeaders());
  }

  /**
   * Catálogos
   */

  public getTiposCreditos(){
    return this.http.get(this.tiposCreditosService, this.authService.getAuthHeaders());
  }

  public getCatalogoPeriodicidad() {
    return { '0': 'Semanal', '1': 'Quincenal', '2': 'Mensual' };
  }

  public getCatalogoTipoCalculo() {
    return { '0': 'Corrida soluta', '1': 'Corrida insoluta', '2': 'Crédito simple' };
  }

  // credito.service.ts
  getConteoTotalPorStatus(filtros: any): Observable<any> {
  let params: URLSearchParams = new URLSearchParams();

  Object.keys(filtros).forEach(key => {
    if (filtros[key] !== undefined && filtros[key] !== null && filtros[key] !== '') {
      params.set(key, filtros[key]);
    }
  });

  let options = this.authService.getAuthHeaders(); // Devuelve un objeto RequestOptions
  options.search = params;

  return this.http.get(`${this.service_url}/conteostatus`, options)
    .map(res => {
      const json = res.json();
     // console.log('Respuesta de conteostatus:', json);
      return json;
    });
}




}



// WEBPACK FOOTER //
// ./src/app/services/creditos.service.ts